export default "__VITE_ASSET__CJHZ2lVs__"